import React from 'react';

const RegButton = ({ text }) => (
  // eslint-disable-next-line react/button-has-type
  <button className="intro__btn">
    <span>{text}</span>
  </button>
);

export default RegButton;
